import { render, staticRenderFns } from "./competitions.vue?vue&type=template&id=494cf04e&scoped=true"
import script from "./competitions.vue?vue&type=script&lang=js"
export * from "./competitions.vue?vue&type=script&lang=js"
import style0 from "./competitions.vue?vue&type=style&index=0&id=494cf04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494cf04e",
  null
  
)

export default component.exports